import React from 'react';
import s from './ToipAllStoriesBtn.scss';

const ToipAllStoriesBtn = ({ isWapView }) =>
  isWapView ? (
    <a href="/toi-plus/all-toi-stories" className={s.all_TP_stories}>
      See All TOI+ Stories
    </a>
  ) : (
    <a href="/toi-plus/all-toi-stories" className={s.all_TP_stories}>
      All
      <img
        src="https://static.toiimg.com/photo/88738139.cms"
        alt="logo"
        width="54"
        height="17"
      />
      Stories
    </a>
  );
export default ToipAllStoriesBtn;
